<template>
  <Collapse
    :id="'id'"
    class="po-info-collapse"
    :title="title"
    :expand="true"
    :withBorder="false"
  >
    <div
      slot="content"
      class="dialog-bg"
    >
      <div class="po-info__content">
        <div class="po-info__left-block">
          <div class="po-info__description">
            <span>{{ purchaseOrder.description }}</span>
          </div>
        </div>
        <div class="po-info__right-block">
          <div class="po-info__amount">
            {{ roundAmount(purchaseOrder.amount) | formatCurrency({currencyCode: purchaseOrder.currencyCode}) }}
          </div>
          <div class="po-info__created-by">
            {{ $t('project.purchaseOrder.createdBy') }}: {{ purchaseOrder.requestedBy }}
          </div>
        </div>
      </div>
      <AttachDocs
        v-if="isTenderAward"
        ref="attachPODocs"
        :resourceId="purchaseOrder.poResourceId"
        :freezeDocTime="purchaseOrder.inviteDate"
        :btnName="attachBtnLabel"
        @update:attachments="updateAttachments"
      />
    </div>
  </Collapse>
</template>

<script>
import lodash from 'lodash'
import { getPurchaseNumber } from '@/api/projects/util'
import AttachDocs from '@/modules/projects/AttachDocs'
import Collapse from '@/controls/Collapse'
import { PROJECT_TYPES } from './consts'

export default {
  name: 'PurchaseOrderPreview',
  components: {
    Collapse,
    AttachDocs,
  },
  props: {
    purchaseOrder: {
      type: Object,
      default: () => {
        const emptyValue = this.$t('emptyValue')
        return {
          number: '',
          description: emptyValue,
          vendorName: emptyValue,
          site: emptyValue,
          amount: emptyValue,
          creator: emptyValue,
        }
      },
    },
    isTenderAward: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: PROJECT_TYPES.PO,
    },
  },
  data () {
    return {
      deep,
      attachments: [],
    }
  },
  computed: {
    title () {
      const tmpTitle = `${this.purchaseOrder.siteId}${this.purchaseOrder.number}`
      return this.type === PROJECT_TYPES.PO ? tmpTitle : `${tmpTitle}-${this.purchaseOrder.revisionNum}`
    },
    attachBtnLabel () {
      switch (this.type) {
        case PROJECT_TYPES.PO:
          return this.$t('action.attachPO')
        case PROJECT_TYPES.CONTRACT:
          return this.$t('action.attachContract')
        default:
          return this.$t('emptyValue')
      }
    },
  },
  methods: {
    roundAmount (amount) {
      // When amount is large, the amount format like 1.0E7, use lodash number to handle, the precision keep 2
      return lodash.round(amount, 3)
    },
    updateAttachments (list) {
      this.attachments = list
      const number = getPurchaseNumber(this.type, this.purchaseOrder)
      this.$emit('createProject:updateAttachments', number, list)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-header {
  margin: 0;
}
.po-info-collapse {
  & ::v-deep .title-container {
    border-bottom: 1px solid #e0e0e0;
  }
}
.dialog-bg {
  height: 100%;
  position: center;
  .po-info__amount, .po-info__created-by {
    text-align: right;
  }
  .po-info-Label--row {
    display: flex;
  }

  .po-info__content {
    padding-top: 15px;
    display: flex;
  }

  .po-info__left-block {
    width: 67%;
  }

  .po-info__right-block {
    width: 33%
  }
}

</style>
